import classNames from "classnames";
import React, { Component } from "react";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.bubble.css";

const editorModules = {
  syntax: false,
  toolbar: [
    ["bold", "italic", "underline"],
    [{ size: ["small", false, "large", "huge"] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["clean"],
  ],
};

// A "what you do best" slide of an Above&Beyond theme: free text, with the
// theme's best practices and - when `ai` is given - its AI highlights offered
// beside it. Clicking an item appends it as a bullet.
// The panels are screen only (report.css hides .report__options in print).
export default class ReportAbHighlights extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentContent: this.props.value ? this.props.value : "",
    };
  }

  // The editor is uncontrolled once typing starts, so only the state, the AI
  // panels and the edit lock re-render it.
  shouldComponentUpdate(nextProps, nextState) {
    const aiState = (ai) =>
      JSON.stringify((ai || []).map((panel) => [panel.items, panel.loading]));

    return (
      JSON.stringify(this.state) !== JSON.stringify(nextState) ||
      this.props.editable !== nextProps.editable ||
      aiState(this.props.ai) !== aiState(nextProps.ai)
    );
  }

  _inputOnChange = (value) => {
    this.props.onChange({
      target: {
        name: this.props.name,
        value: value,
      },
    });

    this.setState({
      currentContent: value,
    });
  };

  _suggestionOnClick = (event) => {
    let current = this.state.currentContent;
    const adding = event.currentTarget.innerHTML;

    if (!current || current.indexOf("<ul>") === -1) {
      current = (current ? current : "") + `<ul><li>${adding}</li></ul>`;
    } else {
      current = current.replace("</ul>", `<li>${adding}</li></ul>`);
    }

    this._inputOnChange(current);
  };

  render() {
    const {
      id,
      additionalClass,
      background,
      content,
      suggestions,
      title,
      editable = true,
      ai,
    } = this.props;

    const { currentContent } = this.state;

    return (
      <div
        className={classNames("report__page__wrapper", additionalClass)}
        id={id}
      >
        <div
          className="report__page report__page--ab"
          style={{
            backgroundImage: background ? `url(${background})` : "none",
          }}
        >
          <div className="report__section--padding">
            <div className="report_ab_highlights">
              <h2 dangerouslySetInnerHTML={{ __html: title }} />
              <ReactQuill
                readOnly={!editable}
                className="report__input"
                theme="bubble"
                modules={editorModules}
                value={currentContent}
                defaultValue={content}
                onChange={this._inputOnChange}
              />
            </div>
          </div>
          <div className="report__ab__badges">
            <img alt="" src="/assets/images/report/ab/badge.png" />
          </div>
        </div>
        <div className="report__options__row">
          <div className="report__options">
            {suggestions.map((item, key) => (
              <div key={key} className="report__options__checkitem">
                <p
                  onClick={editable ? this._suggestionOnClick : null}
                  dangerouslySetInnerHTML={{ __html: item.content }}
                />
              </div>
            ))}
          </div>
          {(ai || [])
            .filter((panel) => panel.onGet)
            .map((panel) => (
              <div
                key={panel.type}
                className="report__options report__options--ai"
              >
                <div className="report__options__aihead">
                  <h3>{panel.heading}</h3>
                  <button
                    type="button"
                    className="button button--small"
                    onClick={panel.onGet}
                    disabled={panel.loading || !editable}
                  >
                    {panel.loading ? "…" : panel.buttonLabel}
                  </button>
                </div>
                {(panel.items || []).map((item, key) => (
                  <div key={key} className="report__options__checkitem">
                    <p
                      onClick={editable ? this._suggestionOnClick : null}
                      dangerouslySetInnerHTML={{ __html: item }}
                    />
                  </div>
                ))}
              </div>
            ))}
        </div>
      </div>
    );
  }
}
